"use client";

import { useRouter } from "next/navigation";
import { useTransition } from "react";

interface BackToHomeProps {
    className?: string;
}

export default function BackToHome({ className }: BackToHomeProps) {
    const router = useRouter();
    const [isPending, startTransition] = useTransition();

    const handleBack = () => {
        startTransition(() => {
            router.push("/");
        });
    };

    return (
        <button
            onClick={handleBack}
            disabled={isPending}
            className={`mb-8 text-blue-400 hover:text-blue-300 transition-colors inline-flex items-center justify-center gap-2 ${className || ""} ${isPending ? "opacity-70 cursor-wait" : ""}`}
        >
            {isPending ? (
                <div className="w-4 h-4 border-2 border-blue-400 border-t-transparent rounded-full animate-spin" />
            ) : (
                <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M10 19l-7-7m0 0l7-7m-7 7h18"
                    />
                </svg>
            )}
            {isPending ? "Returning..." : "Back to Home"}
        </button>
    );
}
